export class AkitaStoreKey {
    public static AUTH_USER = "authUser";
    public static CURRENT_USER = "currentUser";
}